import {Component, Input, OnInit} from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'wsd-delta',
  templateUrl: './delta.component.html',
  styleUrls: ['./delta.component.css']
})
export class DeltaComponent {

  _delta: number;

  @Input()
  set delta(value: number) {
    this._delta = _.round(value, 1);
  }

  @Input()
  showPercentage: boolean = true;

  constructor() {
  }

  get deltaClass() {
    return {
      'fa': true,
      'fa-caret-up text-success': this._delta > 0,
      'fa-caret-down text-danger': this._delta < 0,
      'text-grey': this._delta === 0
    };
  }

  get deltaTextClass() {
    return {
      'text-success': this._delta > 0,
      'text-danger': this._delta < 0,
      'text-grey': this._delta === 0
    };
  }

  get isNumber() {
    return !isNaN(this._delta);
  }
}
